/**
 * Shared styling tokens for the public auth screens (forgot password, new member).
 * The login screen uses its own neutral grey field style; these pages use the
 * plum accent from the Figma design.
 */

export const PLUM = '#4b2a4f';
export const PLUM_BORDER = '#6a3d6e';

export const plumFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    minHeight: 56,
    '& fieldset': { borderColor: PLUM_BORDER, borderWidth: 1 },
    '&:hover fieldset': { borderColor: PLUM },
    '&.Mui-focused fieldset': { borderColor: PLUM, borderWidth: 1.5 },
  },
  '& .MuiOutlinedInput-input': {
    py: 2,
    px: 1.5,
    fontSize: '16px',
    color: '#1a1a1a',
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: '#1a1a1a',
    opacity: 1,
  },
};

export const darkButtonSx = {
  backgroundColor: '#2b2b2b',
  color: '#ffffff',
  borderRadius: '8px',
  minHeight: 40,
  textTransform: 'none' as const,
  fontSize: '16px',
  fontWeight: 500,
  '&:hover': { backgroundColor: '#111111' },
  '&.Mui-disabled': { backgroundColor: '#2b2b2b', color: '#ffffff', opacity: 0.7 },
};

export const cancelLinkSx = {
  color: '#d32f2f',
  textDecoration: 'none',
  fontSize: '16px',
  '&:hover': { textDecoration: 'underline' },
};
